import { useEffect } from 'react';
import { useLocalization, useLocale } from '../../../../../context/Localization/localization';
import { useSetHeaderProps, useSetKioskBannerVisibility } from '../../../../../context/Page/page';
import SingleOptionBox from '../../../../../controls/OptionBoxes/SingleOptionBox';
import css from './LockerOpenIssue.module.scss';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import { IconButton } from '../../../../../controls/IconButton/IconButton';
import { GMSizedIcon } from '../../../../../controls/Icon';
import { GoMotoComponent } from '../../../../../API/GoMoto.types';
import { LockerOpenIssueProps } from './LockerOpenIssue.types';
import { LocalizationType } from '../../../../../context/Localization/localization.types';

/**
 * A help screen that gives the user tips on what they can do to make it easier for the 365 kiosk to
 * scan their QR Code and open the locker. When they are ready to try again, they can click the
 * button to return to the screen with their QR Code for the pick-up appointment.
 *
 * @param onTryAgain - {@link LockerOpenIssueProps.onTryAgain onTryAgain} description.
 */
export const LockerOpenIssue: GoMotoComponent<LockerOpenIssueProps> = ({
    onTryAgain,
}) => {
    const Localization: LocalizationType = useLocalization();
    const locale = useLocale();
    const showBanner = useSetKioskBannerVisibility();
    const setHeader = useSetHeaderProps();
    const navigate: NavigateFunction = useNavigate();

    useEffect(() => {
        showBanner(false);
        setHeader({
            title: Localization.PickupAtLocker,
            rightIcons: [
                <IconButton
                    key={'em-sr-close'}
                    sizedIcon={
                        <GMSizedIcon
                            iconType={'Close'}
                            iconSize={'medium'}
                            ariaLabel={Localization.CloseIcon}
                            title={Localization.ClickToCloseWindow}
                        />
                    }
                    onClick={() => navigate(-1)}
                    ariaLabel={Localization.ClickToCloseWindow}
                    id={Localization.ClickToCloseWindow}
                />,
            ],
        });
    }, [setHeader, showBanner, navigate, Localization, locale]);

    return (
        <SingleOptionBox
            primaryText={
                <div className={css.tipsList}>
                    <div className={css.listHeader}>{Localization.LockerScanningTips}</div>
                    <ol>
                        <li>{Localization.LockerScanningTips1}</li>
                        <li>{Localization.LockerScanningTips2}</li>
                        <li>{Localization.LockerScanningTips3}</li>
                        <li>{Localization.LockerScanningTips4}</li>
                    </ol>
                </div>
            }
            primaryButtonText={Localization.TryAgain}
            onPrimaryClick={onTryAgain}
        />
    );
};
